<template>
  <el-dialog class="stockDetailDialog" :visible.sync="dialogVisible" width="40%">
    <stock-detail :stockDetailObj="stockObj"></stock-detail>
  </el-dialog>
</template>

<script>
import StockDetail from "@/views/plan/info/ResourceDetail.vue";
import Api from '@/components/Api/index.js'
export default {
  data(){
    return{
      dialogVisible:false,
      stockObj:{},
    }
  },
  methods:{
    openDialog(item,productType){
      this.dialogVisible = true
      new Api('resource').stockDetail({stockIds:[item.stockId],productType:productType}).then(res => {
        if (res.status == 200) {
          this.stockObj = res.data[0]
        }
      })
    }
  },
  components:{StockDetail}
}
</script>

<style>

</style>